/**
 * Formats a price object into a localized currency string
 * @param itemPrice - Price object with code, minorUnits, and decimals
 * @param locale - Locale string for number formatting (e.g., 'en-GB', 'de-DE')
 * @returns Formatted price string (e.g., '£5.99') or '0' if price is undefined
 */
export function getPrice(
  itemPrice: { code: string; minorUnits: number; decimals: 2 } | undefined,
  locale: string,
): string {
  if (itemPrice) {
    const price = itemPrice.minorUnits / Math.pow(10, itemPrice.decimals);
    const formattedPrice = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: itemPrice.code,
    }).format(price);
    return formattedPrice;
  } else {
    return '0';
  }
}

